/* eslint-disable @typescript-eslint/no-unused-vars */
import { Injectable } from '@angular/core';
import {
  ActivatedRoute,
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  RouterStateSnapshot
} from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState } from '../../../state/app.state';
import { WorkspaceListFetch } from '../../store/workspace-list.feature';
import { CognitoService } from 'src/app/services/cognito.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class WorkspaceActivatedGuard implements CanActivate, CanActivateChild {
  constructor(
    protected readonly route: ActivatedRoute,
    private readonly store: Store<AppState>,
    private readonly cognitoService: CognitoService
  ) {
    this.fetchWorkspaces();
  }

  async fetchWorkspaces() {
    const isAdmin = await this.cognitoService.isAdmin();
    this.store.dispatch(WorkspaceListFetch({ include_archived: true, include_deleted: isAdmin }));
  }

  canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot) {
    return environment.isWorkspaceActivated
  }

  canActivateChild(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot) {
    return environment.isWorkspaceActivated
  }
}
